import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { FaBell } from "react-icons/fa";
import {
  fetchNotifications,
  markAllRead,
  markSingleRead,
} from "../../redux/slices/notificationSlice";
import styles from "./styles/notificationPanel.module.scss";

dayjs.extend(relativeTime);

export default function NotificationPanel({ onClose }) {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.notification);
  const panelRef = useRef(null);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  useEffect(() => {
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const handleMarkAll = () => {
    dispatch(markAllRead());
  };

  const handleMarkSingle = (id) => {
    dispatch(markSingleRead(id));
  };

  return (
    <div className={styles.panel} ref={panelRef}>
      <div className={styles.header}>
        <span className={styles.headerTitle}>Notifications</span>
        <button className={styles.markAllBtn} onClick={handleMarkAll}>
          Mark all read
        </button>
      </div>

      <div className={styles.list}>
        {loading && <p className={styles.empty}>Loading...</p>}

        {!loading && list.length === 0 && (
          <p className={styles.empty}>No notifications</p>
        )}

        {!loading &&
          list.map((item) => (
            <div
              key={item.id}
              className={`${styles.item} ${item.is_read ? styles.read : styles.unread}`}
              onClick={() => !item.is_read && handleMarkSingle(item.id)}
            >
              <div className={styles.iconWrap}>
                <FaBell />
              </div>
              <div className={styles.body}>
                <p className={styles.title}>{item.title}</p>
                <p className={styles.message}>{item.message}</p>
                <p className={styles.time}>
                  {dayjs(item.created_at).fromNow()}
                </p>
              </div>
              {!item.is_read && <span className={styles.dot} />}
            </div>
          ))}
      </div>
    </div>
  );
}
